export function requireSvgResource() {
	if (WEBPACK4) {
		require.context('./assets/svg/', true, /\.svg$/);
	}
}
